"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shopperContext = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _crossFetch = _interopRequireDefault(require("cross-fetch"));
var _querystring = _interopRequireDefault(require("querystring"));
var _util = require("./util");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
const shopperContext = (usid, config) => {
  return {
    initGuest: () => _initCredentials(usid, {
      grant_type: 'client_credentials'
    }, config),
    initSession: body => _initSession(usid, body, config)
  };
};

// global variable to store credentials
exports.shopperContext = shopperContext;
var _credentials = null;
const getCredentials = () => _credentials;
const setCredentials = val => _credentials = val;
const _initCredentials = (usid, form, config) => {
  return new Promise((resolve, reject) => {
    if (getCredentials()) resolve(getCredentials());
    var formData = _querystring.default.stringify(form);
    var contentLength = formData.length;
    const options = {
      method: 'POST',
      headers: {
        'Content-Length': contentLength.toString(),
        Authorization: (0, _util.getBasicAuth)(config),
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: formData
    };
    (0, _crossFetch.default)(`${(0, _util.getUrl)('auth', config)}oauth2/token${usid ? `?usid=${usid}` : ''}`, options).then( /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)(function* (res) {
        setCredentials(yield res.json());
        resolve(getCredentials());
      });
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()).catch(err => {
      if (err) reject(err);
    });
  });
};
const _initSession = (usid, body, config) => {
  return new Promise((resolve, reject) => {
    const data = JSON.stringify({
      customQualifiers: _objectSpread({}, body)
    });
    const options = {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${getCredentials().access_token}`,
        'Content-Type': 'application/json'
      },
      body: data
    };
    (0, _crossFetch.default)(`${(0, _util.getUrl)('shopper-context', config)}/shopper-context/${usid}`, options).then( /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)(function* (res) {
        const result = yield res.text();
        resolve(result);
      });
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }()).catch(err => {
      if (err) reject(err);
    });
  });
};